/**
 * Statuses this backend uses to reject an expired or invalid token.
 *
 * 403 is included because this API answers expired tokens with 403, not 401.
 * That is safe here because "authenticated but not permitted" is NOT signalled
 * by status: it comes back as a 200 carrying `successful: false` and
 * `unAuthorizedAction: true` in the response body. So a 403 always means the
 * token itself was rejected, and is worth one refresh-and-retry.
 *
 * If that ever changes and the API starts returning 403 for permission denials,
 * remove it here — retrying those would waste a refresh and, when the retry
 * fails the same way, end a perfectly valid session.
 */
export const AUTH_FAILURE_STATUSES: readonly number[] = [401, 403];

export function isAuthFailureStatus(status: number): boolean {
  return AUTH_FAILURE_STATUSES.includes(status);
}
